<template>
  <div class="row confirmation-section">
    <div id="payment-agreements-table" class="col-md-12 materialized">
      <vue-good-table
        :columns="columns"
        :rows="eftAgreements"
        styleClass="table condensed table-hover"
        sortable=false>
        <template slot="table-row" slot-scope="props">
          <td class="text-center" data-title='Member'><span class="data-item">{{ props.row.memberName }}</span>
          </td>
          <td class="text-center" data-title='Agreement'>
            <span class="data-item">{{ props.row.agreement}}</span>
            <br>
            <span class="data-item">{{ '(' + props.row.agreementDescription + ')' }}</span>
          </td>
          <td class="text-center" data-title='Reference Number'>
            <span class="data-item">{{ props.row.referenceNumber }}</span>
          </td>
          <td class="text-center" data-title='Description'>
            <span class="data-item">{{ props.row.description }}</span>
          </td>
          <td class="text-center" data-title='Amount Paid'>
            <span class="data-item">{{ '$' + props.row.balance.toFixed(2) }}</span>
          </td>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaymentAgreementsTable',
    props: {
      agreementData: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        columns: [
          {
            label: 'Member',
            field: 'memberName',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Agreement',
            field: 'agreementId',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Reference Number',
            field: 'referenceNumber',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Description',
            field: 'description',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Amount Paid',
            field: 'amountPaid',
            tdClass: 'text-center',
            thClass: 'text-center'
          }]
      }
    },
    computed: {
      eftAgreements: {
        get: function () {
          return this.agreementData.agreements
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  .btn-print {
    background-color: transparent;
    border-radius: 0;
    padding: 5px 18px;
    border-color: #999;
    top: 15px;
  }
</style>



// WEBPACK FOOTER //
// node_modules/PaymentConfirmation/PaymentAgreementsTable.vue